import React from "react";

const ChatHistory = ({
  chatHistory,
  handleLoadChat,
  handleNewChat,
  handleDeleteChat,
}) => {
  return (
    <div className="col-lg-3 chat-cont-left">
      <div className="card mb-0 flex-fill">
        <div className="chat-header">
          <div className="mb-3 d-flex justify-content-between align-items-center">
            <h6>Lịch sử chat</h6>
            <button className="btn btn-primary btn-sm" onClick={handleNewChat}>
              New Chat
            </button>
          </div>
          <div className="input-icon">
            <span className="input-icon-addon">
              <i className="isax isax-search-normal-14"></i>
            </span>
            <input
              type="text"
              className="form-control form-control-md"
              placeholder="Tìm kiếm lịch sử chat ..."
            />
          </div>
        </div>
        <div className="card-body chat-users-list chat-scroll pt-0">
          {chatHistory.length === 0 ? (
            <p className="text-center">Chưa có cuộc trò chuyện nào</p>
          ) : (
            chatHistory.map((chat) => (
              <div
                key={chat.id}
                className="d-flex justify-content-between chat-member mb-3 align-items-center"
              >
                <a
                  onClick={() => handleLoadChat(chat.id)}
                  style={{ cursor: "pointer", flex: 1 }}
                >
                  <div className="d-flex align-items-center">
                    <div>
                      <h6 className="fs-16 fw-medium mb-1">{chat.summary}</h6>
                      <p className="fs-12 text-muted">{chat.timestamp}</p>
                    </div>
                  </div>
                </a>
                <div className="flex-grow-0">
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDeleteChat(chat.id)}
                    style={{ cursor: "pointer" }}
                    title="Xóa cuộc trò chuyện"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                  >
                    <i className="fa-solid fa-trash-can"></i>
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatHistory;
